import { defaultThemeColors } from '@/plugins/vuetify/themeColors'

// Only app-owned, statically imported SVG artwork should be passed to this helper.
export function themeSvgMarkup(markup) {
  return markup.replace(/\bfill="([^"]+)"/g, (attribute, fill) => {
    const color = fill.toLowerCase()
    if (color === defaultThemeColors.primary.toLowerCase()) {
      return 'fill="rgb(var(--v-theme-primary))"'
    }
    if (color === defaultThemeColors.secondary.toLowerCase()) {
      return 'fill="rgb(var(--v-theme-secondary))"'
    }
    return attribute
  })
}
